/**
 * Created by Rishabh Kumar on 18/12/19
 */
import * as React from "react";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { SectionContext } from "../../utils/EventTrackerConstants";
import AppUtils from "../../utils/AppUtils";

interface SuggestionListProps {
    name?: string
    widgetName?: string
    listItems: any,
    onListItemClick: (listItem: any) => void;
    labelKey?: string;
}

export const SuggestionList: React.SFC<SuggestionListProps> = (props) => {
    const section = React.useContext(SectionContext);
    const onClick = (listItem: any) => {
        LocalStorageUtils.setClickEvents({ value: AppUtils.getRecommendationTagLabel(props.labelKey, listItem), field: props.name, widget: props.widgetName, section: section })
        props.onListItemClick(listItem)
    }

    return <div className="toggle-button-items">
        {
            (props.listItems || []).map((listItem: any, index: number) => {
                return <input
                    className={`toggleButton`} key={`item-${index}`}
                    type="button"
                    value={AppUtils.getRecommendationTagLabel(props.labelKey, listItem)}
                    onClick={() => onClick(listItem)}
                />
            })
        }
    </div>

}